import React, { useEffect, useState } from 'react';
import styles from './optOutLink.module.css';
import { 
    getStudentOptOut, 
    createOrUpdateOptOut,
    isOptOutEnabled
  } from '../services/optOutService';
  import { 
    Modal, 
    ModalHeader, 
    ModalBody, 
    Link,
    Table,
    TableHead,
    TableRow,
    TableHeaderCell,
    TableBody,
    TableCell,
    SwitchField
  } from '@qualtrics/ui-react';
import { EnvelopeClosedIcon } from '@qualtrics/ui-react/icons';

const OptOutLink = ({evaluationTasks, hashedStudentId, brandId, studentId}) => {
  const [isOptOutFeatureEnabled, setIsOptOutEnabled] = useState(false);
  const [studentOptOutList, setStudentOptOut] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const onLinkClick = () => setIsOpen(true);
  const onModalClose = () => setIsOpen(false);

  const createTermIdToTermNameMap = (evaluationTasks) => {
    const termMap = new Map();
    evaluationTasks.forEach((taskGroup) => {
      taskGroup.forEach((task) => {
        if(!termMap.has(task.termId)) {
          termMap.set(task.termId, task.termName);
        }
      });
    });

    return termMap;
  };

  useEffect(() => {
    const getIsOptOutFeatureEnabled = async () => {
      try {
        const isOptOutFeatureEnabled = await isOptOutEnabled(brandId);
        setIsOptOutEnabled(isOptOutFeatureEnabled);
      } catch (err) {
      }
    }

    const getStudentOptOutList = async () => {
      const studentOptOutList = [];
      try {
        for(const termId of createTermIdToTermNameMap(evaluationTasks).keys()) {
          let studentOptOut = await getStudentOptOut(hashedStudentId, termId, brandId);
          if (!studentOptOut) {
            studentOptOut = {
              studentId: studentId,
              termId: termId,
              brandId: brandId,
              optOutDate: null,
              deleteAt: null
            }
          }
          studentOptOutList.push(studentOptOut);
        }
        setStudentOptOut(studentOptOutList);
      } catch (err) {

      }
    }
    getIsOptOutFeatureEnabled();
    getStudentOptOutList();
  }, [evaluationTasks]);

  const updateOptInStatusForTerm = async (isOptedOut, termId) => {
      try {
        await createOrUpdateOptOut(hashedStudentId, termId, brandId, isOptedOut)
        const studentOptOut = await getStudentOptOut(hashedStudentId, termId, brandId);
        const newStudentOptOutList = createNewOptOutList(studentOptOutList, studentOptOut);
        setStudentOptOut(newStudentOptOutList);
      } catch(err) {
      }
  };

  const createNewOptOutList = (studentOptOutList, newOptOut) => {
    const newOptOutList = studentOptOutList.map(
      currOptOut => currOptOut.termId === newOptOut.termId ? newOptOut : currOptOut);

    if(!newOptOutList.includes(newOptOut)) {
      newOptOutList.push(newOptOut);
    }
    return newOptOutList;
  }

  const getTermLabel = (termIdToTermName, termId) => {
    if (termIdToTermName.has(termId)) {
      return termIdToTermName.get(termId);
    }

    return termId;
  }

  const OptOutModalTableBody = () => {
    const termIdToTermName = createTermIdToTermNameMap(evaluationTasks);
    return Array.from(termIdToTermName.keys()).map((termId) => {
      const isOptedOut = studentOptOutList.find(curOptOut => curOptOut.termId === termId)?.optOutDate !== null;
      return (
        <TableRow key={termId}>
          <TableCell className={styles['table-cell']}>
            {getTermLabel(termIdToTermName, termId)}
          </TableCell>
          <TableCell className={styles['table-cell']}>
            <SwitchField
             data-testid = "testId"
              checked={!isOptedOut}
              onChange={(_) => updateOptInStatusForTerm(!isOptedOut, termId)}
              label={isOptedOut ? "Opted Out" : "Opted In"}
            />
          </TableCell>
        </TableRow>
      )
    });
  }

  const OptOutModalBody = () => {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>Term</TableHeaderCell>
            <TableHeaderCell>Receive emails</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <OptOutModalTableBody />
        </TableBody>
      </Table>
    );
  }

  if (!isOptOutFeatureEnabled) {
    return <></>
  }

  return (
    <>
      <Link onClick={onLinkClick} className={styles['opt-out-link']}>
          <EnvelopeClosedIcon />
          <div className={styles['opt-out-link-text']}>
            Opt out of evaluation emails
          </div>
      </Link>
      <Modal open={isOpen} onClose={onModalClose}>
        <ModalHeader>Terms to opt out of emails</ModalHeader>
        <ModalBody>
          <OptOutModalBody />
        </ModalBody>
      </Modal>
    </>
  );
}

export default OptOutLink